import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  // State of current loading screen status
  public isLoading = signal<boolean>(true);

  /**
   * @description Shows Loader Screen
   */
  showLoader = () => {
    this.isLoading.set(true);
  };

  /**
   * @description Hides Loader Screen
   */
  hideLoader = () => {
    this.isLoading.set(false);
  };
}
